module.exports = __webpack_public_path__ + "media/PAG73-02.a2d2da0d.mp3";